import { z } from 'zod'

export const ShippingAddressSchema = z.object({
    company: z.string().nullish(),
    first_name: z.string().min(1),
    last_name: z.string().min(1),
    address_1: z.string().min(1),
    address_2: z.string().nullish(),
    city: z.string().min(1),
    country_code: z.string().min(1),
    province: z.string().nullish(),
    postal_code: z.string().min(1),
    phone: z.string().regex(/^\d+$/).min(1),
})
